import { Col, Row } from "reactstrap"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import React from "react"
import { getPrimaryTextClass } from "helpers/sf_utils"
import { PROSPECT_TABS, REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"
import useFeatureFlags from "hooks/useFeatureFlags"
const BreadCrumbProspect = props => {
    const [isFeatureFlagActive] = useFeatureFlags();

    return (
        <Row>
            <Col xs="12">
                <div className="page-title-box d-sm-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <h4 className="text-capitalize text-black mb-0 me-3">
                            <Link to={props?.link}>
                                <i className={`bx bx-arrow-back ${getPrimaryTextClass()} font-size-16 me-2 bx-sm`} />
                            </Link>
                            {props?.breadcrumbItem}
                        </h4>
                    </div>
                    <div className="">
                        <div >
                            <button
                                type="button"
                                className={`btn btn-${props.activeTab === 'overview' ? 'sfblue' : 'light'}`}
                                style={{ width: "fit-content" }}
                                onClick={props.handleButtonClickOverview}
                            >
                                Lead Details
                            </button>
                            {props?.isConsent && <button
                                type="button"
                                className={`ms-3 btn btn-${props.activeTab === PROSPECT_TABS.CONSENT ? 'sfblue' : 'light'}`}
                                style={{ width: "fit-content" }}
                                onClick={props.handleButtonClickConsent}
                            >
                                Consent
                            </button>}
                            {props?.isCallFromProspects && <button
                                type="button"
                                className={`ms-3 btn btn-${props.activeTab === 'transcription' ? 'sfblue' : 'light'}`}
                                style={{ width: "fit-content" }}
                                onClick={props.handleButtonClickTranscription}
                            >
                                Call Transcription
                            </button>}
                            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSATION_AND_SUMMARY_TAB) && props?.isCallFromProspects && props?.current_account?.call_summary_enabled &&
                                <button
                                    type="button"
                                    className={`btn ms-3 btn-${props.activeTab === PROSPECT_TABS.SUMMARY ? 'sfblue' : 'light'}`}
                                    style={{ width: "fit-content" }}
                                    onClick={props.handleButtonClickSummary}
                                >
                                    Summary / Q&A
                                </button>}
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

BreadCrumbProspect.propTypes = {
    breadcrumbItem: PropTypes.string,
    title: PropTypes.string,
    backOption: PropTypes.bool,
    link: PropTypes.string
}

export default BreadCrumbProspect